export enum Address {
    homepage = '/',
    registration = '/registrace.html',
    info = '/informace.html',
    results = '/vysledky.html',
    video = '/video.html',
    track = '/trat.html',
    contacts = '/kontakty.html',
    resultsPlaceholder = '/vysledky-:year.html',
    rules = '/podminky.html',
}

export default Address;
